

export default {
  locale: 'bn-bd',
  Pagination: {
    items_per_page: '/ পৃষ্ঠা',
    jump_to: 'যাও',
    jump_to_confirm: 'নিশ্চিত',
    page: 'পৃষ্ঠা',
    prev_page: 'আগের পৃষ্ঠা',
    next_page: 'পরের পৃষ্ঠা',
    prev_5: 'পূর্ববর্তী ৫ পৃষ্ঠা',
    next_5: 'পরবর্তী ৫ পৃষ্ঠা',
    prev_3: 'পূর্ববর্তী ৩ পৃষ্ঠা',
    next_3: 'পরবর্তী ৩ পৃষ্ঠা',
    page_size: 'পাতার আকার'
  },
  DatePicker: {
    lang: {
      placeholder: 'তারিখ নির্বাচন',
      yearPlaceholder: 'বছর নির্বাচন',
      quarterPlaceholder: 'কোয়ার্টার নির্বাচন',
      monthPlaceholder: 'মাস নির্বাচন',
      weekPlaceholder: 'সপ্তাহ নির্বাচন',
      rangePlaceholder: ['শুরুর তারিখ', 'শেষ তারিখ'],
      rangeYearPlaceholder: ['শুরুর বছর', 'শেষ বছর'],
      rangeMonthPlaceholder: ['শুরুর মাস', 'শেষ মাস'],
      rangeWeekPlaceholder: ['শুরুর সপ্তাহ', 'শেষ সপ্তাহ'],
      locale: 'bn_BD',
      today: 'আজ',
      now: 'এখন',
      backToToday: 'আজকে ফিরে চলুন',
      ok: 'ওকে',
      clear: 'পরিস্কার',
      month: 'মাস',
      year: 'বছর',
      timeSelect: 'সময় নির্বাচন',
      dateSelect: 'তারিখ নির্বাচন',
      weekSelect: 'সপ্তাহ পছন্দ করুন',
      monthSelect: 'মাস পছন্দ করুন',
      yearSelect: 'বছর পছন্দ করুন',
      decadeSelect: 'একটি দশক পছন্দ করুন',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'গত মাস (PageUp)',
      nextMonth: 'আগামী মাস (PageDown)',
      previousYear: 'গত বছর (Control + left)',
      nextYear: 'আগামী বছর (Control + right)',
      previousDecade: 'গত দশক',
      nextDecade: 'পরের দশক',
      previousCentury: 'গত শতাব্দী',
      nextCentury: 'পরের শতাব্দী'
    },
    timePickerLocale: {
      placeholder: 'সময় নির্বাচন',
      rangePlaceholder: ['সময় শুরু', 'শেষ সময়']
    }
  },
  TimePicker: {
    placeholder: 'সময় নির্বাচন',
    rangePlaceholder: ['সময় শুরু', 'শেষ সময়']
  },
  Calendar: {
    lang: {
      placeholder: 'তারিখ নির্বাচন',
      yearPlaceholder: 'বছর নির্বাচন',
      quarterPlaceholder: 'কোয়ার্টার নির্বাচন',
      monthPlaceholder: 'মাস নির্বাচন',
      weekPlaceholder: 'সপ্তাহ নির্বাচন',
      rangePlaceholder: ['শুরুর তারিখ', 'শেষ তারিখ'],
      rangeYearPlaceholder: ['শুরুর বছর', 'শেষ বছর'],
      rangeMonthPlaceholder: ['শুরুর মাস', 'শেষ মাস'],
      rangeWeekPlaceholder: ['শুরুর সপ্তাহ', 'শেষ সপ্তাহ'],
      locale: 'bn_BD',
      today: 'আজ',
      now: 'এখন',
      backToToday: 'আজকে ফিরে চলুন',
      ok: 'ওকে',
      clear: 'পরিস্কার',
      month: 'মাস',
      year: 'বছর',
      timeSelect: 'সময় নির্বাচন',
      dateSelect: 'তারিখ নির্বাচন',
      weekSelect: 'সপ্তাহ পছন্দ করুন',
      monthSelect: 'মাস পছন্দ করুন',
      yearSelect: 'বছর পছন্দ করুন',
      decadeSelect: 'একটি দশক পছন্দ করুন',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'গত মাস (PageUp)',
      nextMonth: 'আগামী মাস (PageDown)',
      previousYear: 'গত বছর (Control + left)',
      nextYear: 'আগামী বছর (Control + right)',
      previousDecade: 'গত দশক',
      nextDecade: 'পরের দশক',
      previousCentury: 'গত শতাব্দী',
      nextCentury: 'পরের শতাব্দী'
    },
    timePickerLocale: {
      placeholder: 'সময় নির্বাচন',
      rangePlaceholder: ['সময় শুরু', 'শেষ সময়']
    }
  },
  global: {
    placeholder: 'অনুগ্রহ করে নির্বাচন করুন'
  },
  Table: {
    filterTitle: 'ফিল্টার মেনু',
    filterConfirm: 'ঠিক',
    filterReset: 'রিসেট',
    filterEmptyText: 'ফিল্টার নেই',
    emptyText: 'কোনও ডেটা নেই',
    selectAll: 'বর্তমান পৃষ্ঠা নির্বাচন করুন',
    selectInvert: 'বর্তমান পৃষ্ঠাটি উল্টে দিন',
    selectNone: 'সমস্ত ডেটা সাফ করুন',
    selectionAll: 'সমস্ত ডেটা নির্বাচন করুন',
    sortTitle: 'সাজান',
    expand: 'সারি প্রসারিত করুন',
    collapse: 'সারি সঙ্কুচিত করুন',
    triggerDesc: 'অবতরণকে সাজানোর জন্য ক্লিক করুন',
    triggerAsc: 'আরোহী বাছাই করতে ক্লিক করুন',
    cancelSort: 'বাছাই বাতিল করতে ক্লিক করুন'
  },
  Modal: {
    okText: 'ঠিক',
    cancelText: 'বাতিল',
    justOkText: 'ঠিক'
  },
  Popconfirm: {
    okText: 'ঠিক',
    cancelText: 'বাতিল'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'এখানে অনুসন্ধান',
    itemUnit: 'আইটেম',
    itemsUnit: 'আইটেমসমূহ',
    remove: 'অপসারণ',
    selectCurrent: 'বর্তমান পৃষ্ঠা নির্বাচন করুন',
    removeCurrent: 'বর্তমান পৃষ্ঠাটি সরান',
    selectAll: 'সমস্ত ডেটা নির্বাচন করুন',
    removeAll: 'সমস্ত ডেটা সরান',
    selectInvert: 'বর্তমান পৃষ্ঠাটি উল্টে দিন'
  },
  Upload: {
    uploading: 'আপলোড হচ্ছে ...',
    removeFile: 'ফাইল সরান',
    uploadError: 'আপলোডে সমস্যা',
    previewFile: 'ফাইলের পূর্বরূপ',
    downloadFile: 'ফাইল ডাউনলোড'
  },
  Empty: {
    description: 'কোনও ডেটা নেই'
  },
  Icon: {
    icon: 'আইকন'
  },
  Text: {
    edit: 'সম্পাদনা',
    copy: 'অনুলিপি',
    copied: 'অনুলিপি হয়েছে',
    expand: 'বিস্তৃত করা'
  },
  PageHeader: {
    back: 'পেছনে'
  },
  Image: {
    preview: 'পূর্বরূপ'
  }
};
